import NBType, { InferType } from '@netbase/nb-type'
import Insight from '../enums/Insight'
import Sentiment from '../enums/Sentiment'

const SentimentDriverSchema = NBType.object().shape('SentimentDriverSchema', {
  /* @prop */
  insights: NBType.array().of(NBType.enum(Insight)).nullable(),
  /* @prop */
  sentiments: NBType.array().of(NBType.enum(Sentiment)),
  /* @prop */
  terms: NBType.array().of(NBType.string()).nullable()
  /* END */
})
export default SentimentDriverSchema
export type SentimentDriver = InferType<typeof SentimentDriverSchema>
// RESERVE BELOW
